import { render, staticRenderFns } from "./WishingWellDetails.vue?vue&type=template&id=06667441&scoped=true"
import script from "./WishingWellDetails.vue?vue&type=script&lang=js"
export * from "./WishingWellDetails.vue?vue&type=script&lang=js"
import style0 from "./WishingWellDetails.vue?vue&type=style&index=0&id=06667441&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06667441",
  null
  
)

export default component.exports